import React from 'react';
import VisualizationDocPage from '@splunk/visualizations-shared/VisualizationDocPage';
import OptionsDoc from '@splunk/dashboard-visualizations/common/OptionsDoc';
import DocExample from '@splunk/react-docs/DocExample';

import BasicExampleCode from '!!raw-loader!./examples/Basic';

import BasicExample from './examples/Basic';

import optionsSchema from '../optionsSchema';

export default () => (
    <VisualizationDocPage
        title="Markdown"
        examplesSection={[
            <DocExample
                title="Basic Markdown"
                key="basic"
                description="Example of markdown."
                code={BasicExampleCode}
                example={BasicExample}
            />,
        ]}
        optionSection={<OptionsDoc options={optionsSchema} />}
    />
);
